export default __webpack_public_path__ + "static/media/mob-menu-1.7971616f.png";